import React from 'react';

import { useTeacherTests } from 'modules/teacher-detail';

import { TestCard } from 'components';

interface IProps {
  teacherId?: number;
}

const Tests: React.FC<IProps> = ({ teacherId }) => {
  const { teacherTests } = useTeacherTests(teacherId);

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
      {teacherTests?.map(test => (
        <TestCard
          key={test?.test_id}
          isSaved={false}
          testId={test?.test_id}
          lessonName={test?.lesson_name}
          testRating={test?.test_rating}
          teacher={test?.teacher as never}
          subjectName={test?.subject_name}
          viewCount={String(test?.view_count)}
          testCount={String(test?.test_count || 0)}
        />
      ))}
    </div>
  );
};

export default Tests;
